type RemerlindsWindow = Window & {
  hlsJsUrl?: string;
  initializeTurnaroundVideos?: () => void;
};

function getAssetConfig(): HTMLElement | null {
  return document.getElementById("remerlinds-asset-config");
}

export function initTurnaroundLoader(): void {
  const config = getAssetConfig();
  if (!config || config.dataset.turnaroundEnabled !== "true") return;

  const hlsJsUrl = config.dataset.hlsJsUrl;
  const turnaroundVideoScriptUrl = config.dataset.turnaroundVideoScriptUrl;
  if (!turnaroundVideoScriptUrl) return;

  const rw = window as RemerlindsWindow;
  rw.hlsJsUrl = hlsJsUrl;

  const desktopHoverQuery = window.matchMedia(
    "(min-width: 990px) and (hover: hover) and (pointer: fine)"
  );
  let loaded = false;

  const loadTurnaroundScript = (): void => {
    if (loaded || !desktopHoverQuery.matches) return;
    if (!document.querySelector("[data-turnaround-video]")) return;
    loaded = true;

    const script = document.createElement("script");
    script.src = turnaroundVideoScriptUrl;
    script.defer = true;
    script.onerror = () => {
      loaded = false;
    };
    document.head.appendChild(script);
  };

  rw.initializeTurnaroundVideos = loadTurnaroundScript;
  loadTurnaroundScript();

  if (desktopHoverQuery.addEventListener) {
    desktopHoverQuery.addEventListener("change", loadTurnaroundScript, { once: true });
  } else if (desktopHoverQuery.addListener) {
    desktopHoverQuery.addListener(loadTurnaroundScript);
  }
}
